import React, { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import { loginSuccess, logout } from "../redux/actions/LoggedInAction";
import Topbar from "../layouts/TopBar";
import Footer from "../layouts/Footer";
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import DateTime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';
import toast from 'react-hot-toast';
import EventResources from "../resources/EventResources";
import Select from 'react-select';
import moment from "moment";
import DatePicker from 'react-date-picker';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import UserResources from "../resources/UserResources";

function validate(firstname, lastname, email, password, date_of_joining, date_of_birth, location_id) {
    return {
      firstname: firstname.length === 0,
      lastname: lastname.length === 0,
      email: email.length === 0,
      password: password.length === 0,
      date_of_joining: date_of_joining.length === 0,
      date_of_birth: date_of_birth.length === 0,
      location_id: location_id.length === 0,
    };
  }


function MediaBooking({isLoggedIn, loggedInUser, logout}){
    const [startTime, setStartTime] = useState(null);
    const [endTime, setEndTime] = useState(null);
    const [eventDate, setEventDate] = useState(null);
    const [selectedReqItems, setSelectedReqItems] = useState([]);
    const [requirements, setRequirements] = useState([]);
    const [teamMembersOnly, setTeamMembersOnly] = useState(false);
    const [imageFile, setImageFile] = useState(null);
    const [imageUrl, setImageUrl] = useState(null);
    const [formData, setFormData] = useState({
        name: '',
        event_venue: '',
        description: '',
        event_date: '',
        start_time: '',
        end_time: '',
        number_attendees: null, // Assuming it's a Date object, initialize it appropriately
        contact_name: '', // Assuming it's a Date object, initialize it appropriately
        phone: '',
        other_detail: '',
        email: ''
      });   

    const eventImageAlbumId = 'ISdSkJy' // imgur album id
     const PUBLIC_KEY = process.env.REACT_APP_IMAGEKIT_PUBLIC_KEY || "public_Gs9BTDQd5hGInBhWGfz8dJCG9xg=";
    const IMAGEKITALBUM = "/Tlc_Media/Event_Images";
    const resources = new EventResources()
    const userResources = new UserResources()
    const today = new Date();
    const handleEvRequirements = (reqs) => {
        setSelectedReqItems(reqs)
      };

    const handleTeamMembersOnlyEvent = (reqs) => {
        setTeamMembersOnly(reqs)
    };

    const handleEventDate = (date) => {
        setEventDate(date);
    };

    const handleTimeChange = (type, value) => {
        if (type === 'start') {
            setStartTime(value);
        } else if (type === 'end') {
            setEndTime(value);
        }
    };   

    const loadEventVolunteers = () => {
        return resources.get_eventRequirements()
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
          ...prevData,
          [name]: value,
        }));
      };

    const canBeSubmitted = (dataToSubmit) => {
        const errors = validate(dataToSubmit['name'], dataToSubmit['event_venue'], dataToSubmit['description'], dataToSubmit['event_date'], dataToSubmit['start_time'],dataToSubmit['end_time'],dataToSubmit['event_requirements'], dataToSubmit['number_attendees'], dataToSubmit['contact_name'],dataToSubmit['email']);
        const isDisabled = Object.keys(errors).some(x => errors[x]);
        return !isDisabled;
    }

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        setImageFile(file);
        toast('Please Click Upload button to upload the selected image.');
      }; 
      
    
    const uploadToImageKit = async () => {
            if (!imageFile) {
            toast.error('Please select a file.');
            return;
            }

            try {
                // 1. Get signature, token, expire from your backend
                const res = await userResources.get_admin_image_upload();

                if (res.error && res.error.length > 0) {
                    toast.error("Image Server Upload failed. Contact Admin");
                    return;
                }
    
                const { signature, expire, token } = res.body;
                // 2. Build form data with auth + file
                const form = new FormData();
                form.append("file", imageFile);
                form.append("fileName", formData.name || 'event_image');
                form.append("folder", IMAGEKITALBUM);
                form.append("useUniqueFileName", "true");
    
                // auth fields
                form.append("publicKey", PUBLIC_KEY);
                form.append("signature", signature);
                form.append("token", token);
                form.append("expire", expire);
    
                // 3. Upload to ImageKit
                const resp = await fetch("https://upload.imagekit.io/api/v1/files/upload", {
                method: "POST",
                body: form,
                });
    
                if (!resp.ok) throw new Error(await resp.text());
                const json = await resp.json();
                
                // 4. Store CDN URL
                setImageUrl(json.url);
                toast.success("Image Successfully uploaded. Now complete the rest of the form and submit.");
    
            } catch (error) {
                toast.error("Upload failed: " + error.message);
            }
    };

    

    const uploadToImgur = async () => {
        if (!imageFile) {
            toast.error('Please select a file.');
            return;
        }

        try {
          const formData = new FormData();
          formData.append('image', imageFile);
          formData.append('album', eventImageAlbumId);
    
          const response = await fetch('https://api.imgur.com/3/image', {
            method: 'POST',
            headers: {
                Authorization: `Bearer ` + process.env.REACT_APP_Bearer_Token.toString(),
            },
            body: formData,
          });
    
          const data = await response.json();
    
          if (data.success) {
            setImageUrl(data.data.link);         
            toast.success('Image Successfully uploaded. Now complete the rest of the form and submit.');
          } else {
            toast.error('Error Uploading Image, please try again');
            console.error('Error uploading image file:', data);
          }
        } catch (error) {
          toast.error('Error Uploading Image, please try again');
          console.error('Error uploading image:', error);
        }
      };   

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!eventDate || !moment(eventDate).isValid()) {
            toast.error("Please select a valid event date.");
            return;
        }
        if (moment(eventDate).startOf('day').isBefore(moment().startOf('day'))) {
            toast.error("Event date cannot be in the past.");
            return;
        }
        if (!startTime || !moment(startTime).isValid()) {
            toast.error("Please select a valid start time.");
            return;
        }
        if (!endTime || !moment(endTime).isValid()) {
            toast.error("Please select a valid end time.");
            return;
        }

        const combinedStart = moment(moment(eventDate).format('YYYY-MM-DD') + ' ' + moment(startTime).format('HH:mm:ss'));
        if (!combinedStart.isAfter(moment())) {
            toast.error("Event start time must be in the future.");
            return;
        }

        const combinedEnd = moment(moment(eventDate).format('YYYY-MM-DD') + ' ' + moment(endTime).format('HH:mm:ss'));
        if (!combinedEnd.isAfter(combinedStart)) {
            toast.error("End time must be after start time.");
            return;
        }

        // confirm dialog before submission
        if (!window.confirm("Are you sure you want to submit this form?")) {
            return;
        }
        let submitFormData = formData
        // ToDo: Fix this hack: get all data from state
        let evRequirements =[]        
        selectedReqItems.map((requirement) => (
            evRequirements.push(requirement['value'])
        ))
        const event_requirements = evRequirements.join(', ')
        submitFormData['image'] = imageUrl
        submitFormData['event_requirements'] = event_requirements
        submitFormData['event_date'] = moment( eventDate ).format('YYYY-MM-DD HH:mm:ss') 
        submitFormData['start_time'] = moment( eventDate ).format('YYYY-MM-DD ') + moment( startTime ).format('HH:mm:ss') 
        submitFormData['media_setup_time'] = moment( submitFormData['start_time'] ).subtract(90, 'minutes').format('YYYY-MM-DD HH:mm:ss')
        submitFormData['end_time'] = moment( eventDate ).format('YYYY-MM-DD ') + moment( endTime ).format('HH:mm:ss') 
        submitFormData['team_members_only'] = teamMembersOnly['value']
 
        if (!canBeSubmitted(submitFormData)){
            toast.error("Remember to fill out the mandatory fields")
            return
        }
        
        resources.admin_post(submitFormData).then(res => {
            if (res.error.length < 1) {
                toast.success("Thanks for the booking! Your request has been sent for review")
                setTimeout(() => {
                    window.location.href = window.location.origin + '/events';
                  }, 200);
            } else {
                toast.error("Booking Failed: " + res.error)
            }
            }).catch((err) => {
                toast.error("Network Error: " + err);
            });
        
    };

    useEffect(() => {      
        loadEventVolunteers().then(response => {
            setRequirements(response['body']);
        }).catch((err) => {
            toast.error("Network error: " + err)
        });       
        
    }, []);
    
    let evRequirements = []  //dropdown values is the user information
    requirements.map((req, index) => (
        evRequirements.push({value: req['name'] + "-" + req['room'], label: req['name'] + "-" + req['room'] })
    ))

    let members_only= []
    members_only.push({value: true, label: 'Yes' })
    members_only.push({value: false, label: 'No' })
 

    return(
        <Fragment>
            <Topbar/>

            <div className="hero-area">
            <div className="page-banner parallax" style={{backgroundColor:"#003165"}}>
                    <div className="container">
                        <div className="page-banner-text">
                            <h1 style={{color:"#ffa800"}} className="block-title"><strong>Book the Team for an Event</strong></h1>
                        </div>
                    </div>
                </div>
            </div>

            {/* <!-- Main Content --> */}
            <div id="main-container">
                <div className="content">
                    <div className="container" id="openings">
                        <div className="row">
                            <div className="col-md-10 col-sm-10 mx-auto">
                                <div style={{backgroundColor: '#fff', borderRadius: '12px', border: '1px solid #e0e0e0', overflow: 'hidden'}}>
                                    <div style={{backgroundColor: '#003165', padding: '16px 24px'}}>
                                        <h2 style={{color: '#ffa800', margin: 0, fontSize: 'clamp(18px, 4.5vw, 22px)'}}>Book the Team for an Event</h2>
                                        <p style={{color: '#fff', margin: '4px 0 0', fontSize: 'clamp(12px, 3.2vw, 13px)'}}>Tell us in advance of an upcoming event</p>
                                    </div>
                                    <div style={{padding: '24px'}}>
                                        <form onSubmit={handleSubmit}>
                                            <div className="row">
                                                <div className="col-md-6" style={{marginBottom: '16px'}}>
                                                    <label style={{color: '#003165', fontWeight: 'bold', fontSize: 'clamp(13px, 3.5vw, 14px)', marginBottom: '6px', display: 'block'}}>Event Name<span style={{color:"#d80000"}}>*</span></label>
                                                    <input type="text" className="form-control"
                                                        name="name"
                                                        value={formData.name}
                                                        onChange={handleInputChange}
                                                        style={{fontSize: 'clamp(13px, 3.5vw, 14px)'}}
                                                    />
                                                </div>
                                                <div className="col-md-6" style={{marginBottom: '16px'}}>
                                                    <label style={{color: '#003165', fontWeight: 'bold', fontSize: 'clamp(13px, 3.5vw, 14px)', marginBottom: '6px', display: 'block'}}>Location<span style={{color:"#d80000"}}>*</span></label>
                                                    <input type="text" className="form-control"
                                                        name="event_venue"
                                                        value={formData.event_venue}
                                                        onChange={handleInputChange}
                                                        style={{fontSize: 'clamp(13px, 3.5vw, 14px)'}}
                                                    />
                                                </div>
                                            </div>

                                            <div style={{marginBottom: '16px'}}>
                                                <label style={{color: '#003165', fontWeight: 'bold', fontSize: 'clamp(13px, 3.5vw, 14px)', marginBottom: '6px', display: 'block'}}>Event Description<span style={{color:"#d80000"}}>*</span></label>
                                                <input type="text" className="form-control"
                                                    name="description"
                                                    value={formData.description}
                                                    onChange={handleInputChange}
                                                    style={{fontSize: 'clamp(13px, 3.5vw, 14px)'}}
                                                />
                                            </div>

                                            <div className="row">
                                                <div className="col-md-6" style={{marginBottom: '16px'}}>
                                                    <label style={{color: '#003165', fontWeight: 'bold', fontSize: 'clamp(13px, 3.5vw, 14px)', marginBottom: '6px', display: 'block'}}>Event Date<span style={{color:"#d80000"}}>*</span></label>
                                                    <DatePicker
                                                        name="dateOfJoining"
                                                        placeholderText="Select Date"
                                                        value={eventDate}
                                                        onChange={handleEventDate}
                                                        minDate={today}
                                                        dateFormat="yyyy-MM-dd"
                                                    />
                                                </div>
                                                <div className="col-md-6" style={{marginBottom: '16px'}}>
                                                    <label style={{color: '#003165', fontWeight: 'bold', fontSize: 'clamp(13px, 3.5vw, 14px)', marginBottom: '6px', display: 'block'}}>Event Flyer (optional)</label>
                                                    <input
                                                        className="form-control"
                                                        type="file"
                                                        name="productImages"
                                                        id="images"
                                                        onChange={handleImageChange}
                                                        style={{fontSize: 'clamp(13px, 3.5vw, 14px)', marginBottom: '8px'}}
                                                    />
                                                    <button
                                                        type="button"
                                                        onClick={uploadToImageKit}
                                                        style={{backgroundColor:'#8ccd80', color: '#003165', border: 'none', borderRadius: '6px', padding: '8px 20px', cursor: 'pointer', fontWeight: 'bold', fontSize: 'clamp(13px, 3.5vw, 14px)'}}
                                                    >
                                                        Upload Image
                                                    </button>
                                                </div>
                                            </div>

                                            {imageUrl && (
                                                <div style={{marginBottom: '20px', textAlign: 'center'}}>
                                                    <p style={{color: '#35ab7c', fontSize: 'clamp(13px, 3.5vw, 14px)', fontWeight: 'bold', marginBottom: '8px'}}>Flyer uploaded successfully!</p>
                                                    <div style={{maxWidth: '300px', margin: '0 auto', borderRadius: '8px', overflow: 'hidden', border: '2px solid #ffa800'}}>
                                                        <img src={imageUrl} style={{width: '100%', height: 'auto', display: 'block'}} alt="Event Flyer Preview"/>
                                                    </div>
                                                </div>
                                            )}

                                            <div className="row">
                                                <div className="col-md-6" style={{marginBottom: '16px'}}>
                                                    <label style={{color: '#003165', fontWeight: 'bold', fontSize: 'clamp(13px, 3.5vw, 14px)', marginBottom: '6px', display: 'block'}}>Event Start Time<span style={{color:"#d80000"}}>*</span></label>
                                                    <DateTime
                                                        value={startTime}
                                                        onChange={(value) => handleTimeChange('start', value)}
                                                        dateFormat={false}
                                                    />
                                                </div>
                                                <div className="col-md-6" style={{marginBottom: '16px'}}>
                                                    <label style={{color: '#003165', fontWeight: 'bold', fontSize: 'clamp(13px, 3.5vw, 14px)', marginBottom: '6px', display: 'block'}}>Event End Time<span style={{color:"#d80000"}}>*</span></label>
                                                    <DateTime
                                                        value={endTime}
                                                        placeholder="End Time"
                                                        onChange={(value) => handleTimeChange('end', value)}
                                                        dateFormat={false}
                                                    />
                                                </div>
                                            </div>

                                            <div style={{marginBottom: '16px'}}>
                                                <label style={{color: '#003165', fontWeight: 'bold', fontSize: 'clamp(13px, 3.5vw, 14px)', marginBottom: '6px', display: 'block'}}>Event Requirements<span style={{color:"#d80000"}}>*</span></label>
                                                <Select
                                                    name='event_requirements'
                                                    id="event_requirements"
                                                    classNamePrefix='select-css-tag'
                                                    isMulti
                                                    onChange={handleEvRequirements}
                                                    options={evRequirements}
                                                    placeholder="Select multiple requirements"
                                                />
                                            </div>

                                            <div style={{marginBottom: '16px'}}>
                                                <label style={{color: '#003165', fontWeight: 'bold', fontSize: 'clamp(13px, 3.5vw, 14px)', marginBottom: '6px', display: 'block'}}>Number of Attendees<span style={{color:"#d80000"}}>*</span></label>
                                                <input type="number" className="form-control"
                                                    name="number_attendees"
                                                    value={formData.number_attendees}
                                                    onChange={handleInputChange}
                                                    style={{fontSize: 'clamp(13px, 3.5vw, 14px)'}}
                                                />
                                            </div>

                                            <div style={{marginBottom: '16px'}}>
                                                <label style={{color: '#003165', fontWeight: 'bold', fontSize: 'clamp(13px, 3.5vw, 14px)', marginBottom: '6px', display: 'block'}}>Event Contact Person Name<span style={{color:"#d80000"}}>*</span></label>
                                                <input type="text" className="form-control"
                                                    name="contact_name"
                                                    value={formData.contact_name}
                                                    onChange={handleInputChange}
                                                    style={{fontSize: 'clamp(13px, 3.5vw, 14px)'}}
                                                />
                                            </div>

                                            <div className="row">
                                                <div className="col-md-6" style={{marginBottom: '16px'}}>
                                                    <label style={{color: '#003165', fontWeight: 'bold', fontSize: 'clamp(13px, 3.5vw, 14px)', marginBottom: '6px', display: 'block'}}>Contact Phone (optional)</label>
                                                    <input type="number" className="form-control"
                                                        name="phone"
                                                        value={formData.phone}
                                                        onChange={handleInputChange}
                                                        style={{fontSize: 'clamp(13px, 3.5vw, 14px)'}}
                                                    />
                                                </div>
                                                <div className="col-md-6" style={{marginBottom: '16px'}}>
                                                    <label style={{color: '#003165', fontWeight: 'bold', fontSize: 'clamp(13px, 3.5vw, 14px)', marginBottom: '6px', display: 'block'}}>Contact Email<span style={{color:"#d80000"}}>*</span></label>
                                                    <input type="email" className="form-control"
                                                        name="email"
                                                        value={formData.email}
                                                        onChange={handleInputChange}
                                                        style={{fontSize: 'clamp(13px, 3.5vw, 14px)'}}
                                                    />
                                                </div>
                                            </div>

                                            <div style={{marginBottom: '16px'}}>
                                                <label style={{color: '#003165', fontWeight: 'bold', fontSize: 'clamp(13px, 3.5vw, 14px)', marginBottom: '6px', display: 'block'}}>Other Event Details (optional)</label>
                                                <textarea className="form-control" rows="3"
                                                    name="other_detail"
                                                    value={formData.other_detail}
                                                    onChange={handleInputChange}
                                                    placeholder="Any additional information about the event"
                                                    style={{fontSize: 'clamp(13px, 3.5vw, 14px)'}}
                                                />
                                            </div>

                                            {(isLoggedIn && loggedInUser['role.name'] === 'admin') && (
                                                <div style={{marginBottom: '16px'}}>
                                                    <label style={{color: '#003165', fontWeight: 'bold', fontSize: 'clamp(13px, 3.5vw, 14px)', marginBottom: '6px', display: 'block'}}>Team Members Only Event?<span style={{color:"#d80000"}}>*</span></label>
                                                    <Select
                                                        name='team_members_only'
                                                        id="team_members_only"
                                                        classNamePrefix='select-css-tag'
                                                        onChange={handleTeamMembersOnlyEvent}
                                                        options={members_only}
                                                        placeholder="Select one"
                                                    />
                                                </div>
                                            )}

                                            <div style={{backgroundColor: '#e8f8f0', borderRadius: '8px', padding: '12px 16px', marginBottom: '20px'}}>
                                                <p style={{color: '#35ab7c', margin: 0, fontSize: 'clamp(12px, 3.2vw, 13px)', fontWeight: 'bold'}}>✓ Please check your email and our Events page after confirmation</p>
                                            </div>

                                            <div style={{marginTop: '24px'}}>
                                                <input style={{backgroundColor:"#8ccd80", color: '#003165', fontWeight: 'bold', fontSize: 'clamp(14px, 3.8vw, 16px)', padding: '12px 40px', border: 'none', borderRadius: '6px', cursor: 'pointer'}} type="submit" className="btn btn-primary" value="Submit Booking"/>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer/>     
        </Fragment>
    )
}

const mapStateToProps = (state) => {
    return{
       isLoggedIn: state.authReducer.isLoggedIn,
       loggedInUser: state.authReducer.user
    };
    
};

const mapDispatchToProps = {
    logout
};

export default connect(mapStateToProps, mapDispatchToProps)(MediaBooking);